import React, { useState, useRef } from 'react'
import shape from "../assets/Images/shapes/Thred 05-01.png"
import play from "../assets/Images/shapes/Play Button-01.png"
import fronthospital from "../assets/Images/fronhospital.jpg"
import videoTour from '../assets/Images/video1 (1).mp4'
export default function TakeVideo() {
  const [isPlaying, setIsPlaying] = useState(false)
  const videoRef = useRef(null)

  const handlePlay = () => {
    setIsPlaying(true)
    setTimeout(() => {
      if (videoRef.current) {
        if (videoRef.current.requestFullscreen) {
          videoRef.current.requestFullscreen()
        } else if (videoRef.current.webkitRequestFullscreen) {
          videoRef.current.webkitRequestFullscreen()
        } else if (videoRef.current.mozRequestFullScreen) {
          videoRef.current.mozRequestFullScreen()
        } else if (videoRef.current.msRequestFullscreen) {
          videoRef.current.msRequestFullscreen()
        }
        videoRef.current.play()
      }
    }, 100)
  }
  return (
    <div>
      <div className='relative overflow-hidden py-[88px] lg:py-[240px]'>
        <div className='max-w-[1340px] mx-auto relative'>
          <div className='relative'>
            <div className='z-[1]'>
              <div className='mb-[48px]'>
                <div className=' block md:flex gap-[12px] justify-center items-center'>
                  <div className='w-full xl:w-[510px] me-auto' data-aos="fade-right">
                    <h2 className='text-[36px] md:text-[48px] lg:text-[58px] font-heading  leading-[1.138em] text-thickGreen'>
                      Take a look at our exceptional facilities
                    </h2>
                  </div>
                  <div className='w-full xl:w-[498px] ms-auto' data-aos="fade-left">
                    <p className='mb-[16px] lg:mb-[32px] text-paraGreen font-body font-medium leading-[1.667em] text-[18px]'>

                    </p>
                  </div>
                </div>
              </div>
              <div className='relative z-10 flex justify-center items-center rounded-[24px] overflow-hidden' data-aos="fade-up">
                {!isPlaying ? (
                  <>
                    <img
                      src={fronthospital}
                      alt='hospital video'
                      className='w-full h-auto object-cover cursor-pointer'
                      onClick={handlePlay}
                    />
                    <div className='absolute inset-0 bg-black bg-opacity-30 flex justify-center items-center'></div>
                    <button
                      onClick={handlePlay}
                      className='absolute flex justify-center items-center bg-[#f17e21] rounded-full w-[60px] lg:w-[156px] h-[60px] lg:h-[156px] p-2'
                      aria-label='Play Video'
                    >
                      <img
                        src={play}
                        alt='Play Icon'
                        className='w-8 lg:w-16 h-8 lg:h-16'
                      />
                    </button>
                  </>
                ) : (
                  <video
                    ref={videoRef}
                    src={videoTour}
                    className='w-full h-auto object-contain'
                    controls
                    autoPlay title='hospitals video'
                    onEnded={() => setIsPlaying(false)}
                  />
                )}
              </div>
              <div className='absolute inline-block inset-[3%_0%_0%_14%] top-[45%] lg:top-[15%] left-[-8%] -right-24'>
                <img src={shape} alt="shape" className='max-w-full' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
